import React from "react";
import TimeLearner from "./TimeLearner";
import "./learner.css";

export const Learner: React.FC = () => {
  return (
    <div className="learner">
      <TimeLearner />
    </div>
  );
};
